<template>
  <div class="modal fade" id="terms-modal-input" role="dialog">
    <div class="modal-dialog modal-md">
      <!-- Modal content-->
      <div class="modal-content bsz">
        <div class="modal-body">
          <div class="terms-wrapper">
            <button type="button" class="btn btn-default btn-back" data-dismiss="modal">
              <i class="ic-back"></i>
            </button>
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-12">
                  <h3 class="text-center">
                    <strong>TERMS OF USE</strong>
                  </h3>

                  <p>
                    These terms will apply to your use of our site, which includes
                    accessing our site, browsing it, or registering to use any of our
                    services. Please read these terms carefully before you start to use
                    our site because, by using it, you confirm that you accept these terms
                    and that you agree to comply with them and any applicable laws and
                    regulations. If you do not agree to these terms, you must not use our
                    site.
                  </p>
                  <p>
                    These terms of use (together with the documents referred to in them)
                    tell you the terms on which you may make use of our website and any of
                    its sub domains (“our site”), whether as a guest or a registered
                    member.
                  </p>
                  <p>
                    If you are using our site on behalf of an organization of which you
                    are an employee, officer, agent or other contractor, such organization
                    will be responsible to us for ensuring you and any other person who
                    uses our site on the organization’s behalf complies with these terms
                    of use. You confirm that you have the authority to accept such
                    responsibility on behalf of your organization.
                  </p>

                  <h4>OTHER APPLICABLE TERMS</h4>
                  <p>
                    These terms of use refer to our privacy and cookies policy, which also
                    applies to your use of our site.
                  </p>
                  <p>
                    We make certain content on our site available to all users. However,
                    registered users are able to see other parts of our site that contain
                    confidential information. You will need to register as a user and
                    agree to a non-disclosure agreement in order to see such information.
                    The terms of the non-disclosure agreement form part of our agreement
                    with registered users.
                  </p>
                  <p>
                    For regulatory and legal reasons, before you are able to see details
                    of any live investment opportunity, or invest in any opportunity on
                    our site, you will need to confirm that you fall within a category of
                    permitted investors and agree to additional terms and conditions
                    governing each investment on our site (a “subscription agreement”). We
                    will make the subscription agreement available to you before you
                    invest in any opportunity. The terms of the subscription agreement
                    will apply to your use of our site once you have agreed to the
                    subscription agreement.
                  </p>

                  <h4>CHANGE TO THESE TERMS AND OUR SITE</h4>
                  <p>
                    We may revise these terms of use at any time by amending this page.
                    Please check this page from time to time to take notice of any changes
                    we make, as they are binding on you.
                  </p>
                  <p>
                    We may update our site from time to time and may change the content at
                    any time. However, please note that any of the content on our site
                    could be out of date at any given time and we are under no obligation
                    to update it.
                  </p>

                  <h4>ACCESSING OUR SITE</h4>
                  <p>Our site is made available free of charge.</p>
                  <p>
                    We reserve the right to restrict access to some parts of our site to
                    registered users and registered investors.
                  </p>
                  <p>
                    We do not guarantee that our site, or any content on it, will always
                    be available or be uninterrupted or that it will be free from errors.
                    Access to our site is permitted on a temporary basis. We may suspend,
                    withdraw, discontinue or change all or any part of our site without
                    notice. We will not be liable to you if for any reason our site is
                    unavailable at any time or for any period.
                  </p>
                  <p>
                    You are responsible for making all arrangements necessary for you to
                    have access to our site.
                  </p>
                  <p>
                    You are also responsible for ensuring that all persons who access our
                    site through your internet connection are aware of these terms of use
                    and other applicable terms and conditions, and that they comply with
                    them.
                  </p>

                  <h4>ACCOUNTS AND PASSWORDS</h4>
                  <p>
                    If you choose, or you are provided with, a user identification code,
                    password or any other piece of information as part of our security
                    procedures, you must treat such information as confidential. You must
                    not disclose it to any other person.
                  </p>
                  <p>
                    We have the right to disable any user identification code or password,
                    whether chosen by you or allocated by us, at any time, if in our
                    reasonable opinion you have failed to comply with any of the
                    provisions of these terms of use.
                  </p>
                  <p>
                    If you know or suspect that anyone other than you know your user
                    identification code or password, you must promptly notify us.
                  </p>

                  <h4>INTELLECTUAL PROPERTY RIGHTS</h4>
                  <p>
                    We are the owner or the licensee of all intellectual property rights
                    in our site, including the material published on it and the software
                    and programming behind our site. Those works are protected by
                    copyright laws and treaties around the world. All such rights are
                    reserved.
                  </p>
                  <p>
                    You may print off one copy, and may download extracts, of any page(s)
                    from our site for your personal use and you may draw the attention of
                    others within your organization to content posted on our site. You
                    must not use our content in a way that may:
                  </p>
                  <p>
                    be defamatory, deceptive or misleading, obscene, offensive, sexually
                    explicit, hateful or inflammatory or to harass, upset, embarrass,
                    alarm or annoy any other person or invade any person’s privacy;
                  </p>
                  <p>
                    promote discrimination on race, sex, religion, nationality,
                    disability, sexual orientation or age, sexually explicit material,
                    violence or any illegal activity;
                  </p>
                  <p>
                    infringe any copyright, database right or trade mark of any person;
                  </p>
                  <p>
                    breach any legal duty owed to a third party, such as a contractual
                    duty or a duty of confidence;
                  </p>
                  <p>
                    give the impression that it emanates from us, if this is not the case;
                    or
                  </p>
                  <p>assist any unlawful act.</p>
                  <p>
                    Our status (and that of any identified contributors) as the authors of
                    content on our site must always be acknowledged.
                  </p>
                  <p>
                    If you print off, copy or download any part of our site in breach of
                    these terms of use, your right to use our site will cease immediately
                    and you must, at our option, return or destroy any copies of the
                    materials you have made.
                  </p>

                  <h4>RELIANCE ON INFORMATION</h4>
                  <p>
                    The content on our site is provided for general information only. It
                    is not intended to amount to advice on which you should rely. You must
                    obtain professional or specialist advice before taking, or refraining
                    from, any action on the basis of the content on our site.
                  </p>
                  <p>
                    Although we make reasonable efforts to update the information on our
                    site, we make no representations, warranties or guarantees, whether
                    express or implied, that the content on our site is accurate, complete
                    or up-to-date.
                  </p>

                  <h4>LIMITATION ON OUR LIABILITY</h4>
                  <p>
                    Nothing in these terms of use excludes or limits our liability for
                    death or personal injury arising from our negligence, or our fraud or
                    fraudulent misrepresentation, or any other liability that cannot be
                    excluded or limited by Singapore law.
                  </p>
                  <p>
                    To the extent permitted by law, we exclude all conditions, warranties,
                    representations or other terms which may apply to our site or any
                    content on it, whether express or implied. We will not be liable to
                    any user for any loss or damage, whether in contract, tort (including
                    negligence), breach of statutory duty or otherwise, even if
                    foreseeable, arising under or in connection with your use of, or
                    inability to use, our site or your reliance on any content on our
                    site.
                  </p>
                  <p>We will not be liable to you for:</p>
                  <p>loss of profits, sales, business, or revenue;</p>
                  <p>business interruption;</p>
                  <p>loss of anticipated savings;</p>
                  <p>loss of business opportunity, goodwill or reputation; or</p>
                  <p>any indirect or consequential loss or damage.</p>

                  <h4>UPLOADING CONTENT TO OUR SITE</h4>
                  <p>
                    Whenever you make use of a feature that allows you to upload or post
                    content to or on our site, or to make contact with other users of our
                    site, you must comply with the content standards set out in these
                    terms of use.
                  </p>
                  <p>
                    Any content uploaded or posted by you (“Your Content”) must be
                    accurate (where it states facts), be genuinely held (where it states
                    opinions) and comply with applicable law in the SG and any other
                    country from which it is sent. Your Content must not:
                  </p>
                  <p>
                    be defamatory, deceptive or misleading, obscene, offensive, sexually
                    explicit, hateful or inflammatory or likely to harass, upset,
                    embarrass, alarm or annoy any other person or invade any person’s
                    privacy;
                  </p>
                  <p>
                    promote discrimination on race, sex, religion, nationality,
                    disability, sexual orientation or age, sexually explicit material,
                    violence or any illegal activity;
                  </p>
                  <p>
                    infringe any copyright, database right or trade mark of any person;
                  </p>
                  <p>
                    breach any legal duty owed to a third party, such as a contractual
                    duty or a duty of confidence;
                  </p>
                  <p>
                    give the impression that it emanates from us, if this is not the case;
                    or
                  </p>
                  <p>assist any unlawful act.</p>
                  <p>
                    You agree that Your Content will comply with the standards set out in
                    these terms. Your content will be considered non-confidential and
                    non-proprietary. You grant the following royalty free, perpetual,
                    non-exclusive licenses in relation to Your Content:
                  </p>
                  <p>
                    a license for us to use Your Content for all purposes in connection
                    with our business.
                  </p>
                  <p>
                    a license for all other visitors to our site to use any of Your
                    Content for all purposes in connection with their use of our site.
                  </p>
                  <p>
                    We may disclose your identity to any third party who is claiming that
                    any of Your Content constitutes a violation of their intellectual
                    property rights, or of their right to privacy.
                  </p>
                  <p>
                    We may also remove all or any of Your Content from the Website if, in
                    our opinion, it does not comply with these terms of use.
                  </p>
                  <p>
                    The views expressed by other visitors to our site do not represent our
                    views or values.
                  </p>

                  <h4>VIRUSES</h4>
                  <p>
                    We do not guarantee that our site will be secure or free from bugs or
                    viruses. We will not be liable for any loss or damage caused by a
                    virus, distributed denial-of-service attack or other technologically
                    harmful material that may infect your computer equipment, computer
                    programs, data or other proprietary material due to your use of our
                    site, or to your downloading of any content on it, or on any website
                    linked to it. You should use your own virus protection software.
                  </p>
                  <p>
                    You must not misuse our site by knowingly introducing viruses,
                    trojans, worms, logic bombs or other material which is malicious or
                    technologically harmful. You must not attempt to gain unauthorized
                    access to our site, the server on which our site is stored or any
                    server, computer or database connected to our site. You must not
                    attack our site via a denial-of-service attack or a distributed
                    denial-of service attack.
                  </p>

                  <h4>LINKING TO OUR SITE</h4>
                  <p>
                    You may link to our home page, provided you do so in a way that is
                    fair and legal and does not damage our reputation or take advantage of
                    it. We reserve the right to withdraw linking permission without
                    notice.
                  </p>
                  <p>
                    You must not establish a link in such a way as to suggest any form of
                    association, approval or endorsement on our part where none exists or
                    establish a link to our site in any website that is not owned by you.
                  </p>
                  <p>
                    Our site must not be framed on any other site and you may not create a
                    link to any part of our site other than the home page.
                  </p>

                  <h4>THIRD PARTY LINKS AND RESOURCES ON OUR SITE</h4>
                  <p>
                    Where our site contains links to other sites and resources provided by
                    third parties, these links are provided for your information only.
                  </p>
                  <p>
                    We have no control over the contents of those sites or resources and
                    assume no responsibility for those contents. Such links should not be
                    interpreted as endorsement by us of those linked websites. We will not
                    be liable for any loss or damage that may arise from your use of them.
                  </p>

                  <h4>APPLICABLE LAW</h4>
                  <p>
                    These terms of use are governed by Singapore law. You and we both
                    agree to that the courts of Singapore will have non-exclusive
                    jurisdiction to deal with any disputes arising in relation to your use
                    of our site.
                  </p>

                  <h5>&copy;{{ thisYear }} {{ brands }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    thisYear: function () {
      return new Date().getFullYear();
    },
    brands: function () {
      return process.env.BRAND_NAME.toUpperCase();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Terms.vue